import { render, staticRenderFns } from "./roaming.vue?vue&type=template&id=0528e9f7&scoped=true&lang=pug"
import script from "./roaming.vue?vue&type=script&lang=js"
export * from "./roaming.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=0528e9f7&prod&lang=scss&scoped=true&external"
import style1 from "./roaming.vue?vue&type=style&index=1&id=0528e9f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528e9f7",
  null
  
)

export default component.exports